import React from 'react';

const PermissionAlert = () => {
    const handleReload = () => {
        window.location.href = '/'
    }
    return (
        <div className="pa-overlay">
            <div className="pa-card">
                {/* Close button */}
                <button
                    onClick={handleReload}
                    className="pa-close-btn"
                    aria-label="Close"
                >
                    &times;
                </button>

                {/* Icon */}
                <div className="pa-icon">
                    <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                        <line x1="12" y1="8" x2="12" y2="12" />
                        <line x1="12" y1="16" x2="12.01" y2="16" />
                    </svg>
                </div>

                {/* Title */}
                <h2 className="pa-title">Permissions Updated</h2>

                {/* Message */}
                <p className="pa-message">
                    Your role permissions have been changed by the administrator. Please reload to apply the latest changes.
                </p>

                {/* OK Button */}
                <button onClick={handleReload} className="pa-ok-btn">
                    Reload Now
                </button>
            </div>
        </div>
    )
}

export default PermissionAlert